import axios from "axios";
import React, { useEffect, useState } from "react";
import useRazorpay from "react-razorpay";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { addAddressforOrder, getNewOrder } from "../apiCalls/order";
import { applyCoupon } from "../apiCalls/coupon";
import { BASE_URL } from "../requestMethods";
import { toast } from "react-toastify";
import Breadcrumb from "../components/Breadcrumb/Breadcrumb";
import { emptyCart } from "../apiCalls/cart";

const Payment = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const cart = useSelector((state) => state.cart.products);
  const user = useSelector((state) => state.user.currentUser);
  const Razorpay = useRazorpay();
  const [subTotalAmount, setSubTotalAmount] = useState(0);
  const [payAmount, setPayAmount] = useState(0);
  const [paymentMethod, setPaymentMethod] = useState("razorpay");
  const [couponValue, setCouponValue] = useState("");
  const [checkCoupon, setCheckCoupon] = useState(false);
  const [couponData, setCouponData] = useState({
    savedAmount: "",
    couponName: "",
    couponId: "",
    couponType: "",
  });

  console.log("paymentMethod", paymentMethod);
  const onOptionChange = (e) => {
    console.log(e.target.value, "value pay");
    setPaymentMethod(e.target.value);
  };

  const initialValues = {
    userId: user?._id,
    fullName: "",
    email: "",
    mobileNumber: "",
    altMobileNumber: "",
    address: "",
    landmark: "",
    pincode: "",
    city: "",
    state: "",
    notes: "",
  };

  const [formValues, setFormValues] = useState(initialValues);
  const [formErrors, setFormErrors] = useState({});
  const [submit, setSubmit] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target; // take name and value from input in destructring
    setFormValues({ ...formValues, [name]: value });
  };

  useEffect(() => {
    let proLi = cart[0]?.cartItems?.map(
      (product) => product.productId.price * product.quantity
    );
    setSubTotalAmount(
      parseInt(proLi?.reduce((partialSum, a) => partialSum + a, 0))
    );

    setPayAmount(
      Math.round((subTotalAmount * 12) / 100) +
        subTotalAmount -
        Math.round((subTotalAmount * 5) / 100)
    );
  }, [subTotalAmount]);

  const validate = (values) => {
    const errors = {};
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;

    if (
      !/^[a-z A-Z]+$/.test(values.fullName) ||
      /^[ ]+$/.test(values.fullName)
    ) {
      errors.fullName = "Name is not valid";
    }
    if (!values.fullName) {
      errors.fullName = "Name is Required";
    }

    if (!values.email) {
      errors.email = "Email is Required";
    }
    if (!regex.test(values.email) && values.email) {
      errors.email = "Email is not valid";
    }

    if (!/^[0-9]+$/.test(values.price)) {
      errors.price = "Price is not valid";
    }

    if (!values.price) {
      errors.price = "Price is Required";
    }

    if (!/^[0-9]+$/.test(values.oldPrice)) {
      errors.oldPrice = "old Price is not valid";
    }

    if (!values.oldPrice) {
      errors.oldPrice = "Old Price is Required";
    }

    if (values.categories.length < 1) {
      errors.categories = "Categories is Required";
    }

    if (values.subCategories.length < 1) {
      errors.subCategories = "Sub Categories is Required";
    }

    if (values.size.length < 1) {
      errors.size = "Size is Required";
    }

    if (values.color.length < 1) {
      errors.color = "Color is Required";
    }

    if (!values.description) {
      errors.description = "Description is Required";
    }

    if (!values.benefits) {
      errors.benefits = "Benefits is Required";
    }

    if (values.mainImg.length < 1) {
      errors.mainImg = "Main Img is Required";
    }

    if (values.multipleimg.length < 1) {
      errors.multipleimg = "Gallery Images are Required";
    }
    return errors;
  };

  const applyValidCoupon = async (e) => {
    e.preventDefault();
    console.log(couponValue, "couponclaeu");
    let obj = {
      couponName: couponValue,
      totalAmount: payAmount,
    };
    const res = await applyCoupon(obj);
    if (res?.data?.status === true) {
      toast.success(`🦄 ${res.data.message}`);
      console.log(res.data.data, "data");
      // setCouponData(res.data.data);
      setCouponData({
        savedAmount: res.data.data.savedAmount,
        couponName: res.data.data.couponName,
        couponId: res.data.data.id,
        couponType: res.data.data.discountType,
      });
      setPayAmount(res.data.data.amount);
      setCheckCoupon(true);
    }
    // console.log(res, "get data from obj");
  };

  const newOrder = async (e) => {
    e.preventDefault();
    try {
      console.log(formValues, "form values");
      const res = await addAddressforOrder(formValues);
      // console.log(res.data.data._id, "res for shiping add");
      if (res.status === 200 && paymentMethod === "razorpay") {
        handlePayment(res.data.data._id);
      } else if (res.status === 200 && paymentMethod === "cod") {
        console.log("bro order is from COD");
        generateOrder(res?.data?.data?._id);
      }
    } catch (err) {
      console.log(err, "error on new order");
    }
  };

  const handlePayment = async (shippingAdd) => {
    // e.preventDefault();
    try {
      const orderUrl = `${BASE_URL}payment/razorpaypayment`;
      const { data } = await axios.post(orderUrl, {
        amount: payAmount,
      });
      console.log("RazorPayData", data.data);
      initPayment(data.data, shippingAdd);
    } catch (error) {
      console.log(error);
    }
  };

  const initPayment = (data, shippingAdd) => {
    const options = {
      key: "rzp_test_E2Ces3INjWxX86",
      amount: data.amount,
      currency: data.currency,
      name: "Rohit Ecommerce",
      description: "Test Transaction",
      image:
        "https://d16py1fyt83ijv.cloudfront.net/vedobi/assets/img/logo/logo.webp",
      order_id: data.id,
      handler: async (response) => {
        try {
          const verifyUrl = `${BASE_URL}payment/verify`;
          const res = await axios.post(verifyUrl, response);
          console.log(res, "res for payment");
          if (res.data.status === "success") {
            generateOrder(shippingAdd);
          }
        } catch (error) {
          console.log(error, "error in payment page");
        }
      },
      theme: {
        color: "#3399cc",
      },
    };
    const rzp1 = new Razorpay(options);
    rzp1.open();
  };

  const generateOrder = async (shippingAdd) => {
    // console.log(couponData, "couponData");
    try {
      let obj = {
        userId: user?._id,
        productItems: cart[0]?.cartItems,
        payAmount: payAmount,
        address: shippingAdd,
        paymentMethod: paymentMethod,
        couponData: couponData
        // savedAmount: couponData,
        // couponName: couponData,
        // couponId: couponData,
        // couponType: couponData,
      };
      console.log(obj, 'order obj')
    // return;

      const res = await getNewOrder(obj);
      if (res.data.status === "success") {
        console.log("Empty cart baby");
        emptyCart(dispatch, user?._id)
        
        navigate("/success", { state: res.data.data });
      }
      console.log(res.data.status, "res for order");
    } catch (err) {
      console.log(err, "err at generate order");
    }
  };

  return (
    <>
      <Breadcrumb
        activeName={"Payment"}
        middleName={"My Cart"}
        middleUrl={"/cart"}
      />

      <section className="payment">
        <div className="container">
          <div className="row">
            <div className="col-full">
              <form>
                <div className="payment-data">
                  <div className="payment-form">
                    <div className="from-tab">
                      <div className="form-block-title mb-1">
                        <h2 className="title">Payment Details</h2>
                      </div>
                      <div className="input-groups mb-1">
                        <div className="input-field">
                          <label>
                            Full Name<span className="text-red">*</span>
                          </label>
                          <input
                            name="fullName"
                            type="text"
                            placeholder="Rohit Yadav"
                            value={formValues.fullName}
                            onChange={handleChange}
                          />
                        </div>

                        <div className="input-field">
                          <label>
                            Email<span className="text-red">*</span>
                          </label>

                          <input
                            type="text"
                            placeholder="rohit892051182@gmail.com"
                            name="email"
                            value={formValues.email}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div className="input-groups mb-1">
                        <div className="input-field">
                          <label>
                            Mobile No.<span className="text-red">*</span>
                          </label>
                          <input
                            type="text"
                            name="mobileNumber"
                            value={formValues.mobileNumber}
                            onChange={handleChange}
                            placeholder="8920511882"
                          />
                        </div>

                        <div className="input-field">
                          <label>Alternate Mobile No.</label>

                          <input
                            type="text"
                            name="altMobileNumber"
                            value={formValues.altMobileNumber}
                            onChange={handleChange}
                            placeholder="9891076070"
                          />
                        </div>
                      </div>
                      <div className="input-groups mb-1">
                        <div className="input-field address">
                          <label>
                            Address.<span className="text-red">*</span>
                          </label>

                          <textarea
                            name="address"
                            value={formValues.address}
                            onChange={handleChange}
                            placeholder="Address"
                            rows="3"
                          />
                        </div>
                      </div>
                      <div className="input-groups mb-1">
                        <div className="input-field landmark">
                          <label>Landmark</label>

                          <input
                            type="text"
                            placeholder="Near Shiv Mandir"
                            name="landmark"
                            value={formValues.landmark}
                            onChange={handleChange}
                          />
                        </div>
                        <div className="input-field pincode">
                          <label>
                            Post/Zip Code<span className="text-red">*</span>
                          </label>
                          <input
                            type="text"
                            name="pincode"
                            placeholder="Pincode"
                            value={formValues.pincode}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div className="input-groups mb-1">
                        <div className="input-field city">
                          <label>
                            City<span className="text-red">*</span>
                          </label>
                          <input
                            type="text"
                            placeholder="New Delhi"
                            name="city"
                            value={formValues.city}
                            onChange={handleChange}
                          />
                        </div>

                        <div className="input-field state">
                          <label>
                            Select State<span className="text-red">*</span>
                          </label>

                          <select
                            name="state"
                            id="state"
                            onChange={handleChange}
                            value={formValues.state}
                          >
                            <option value="0">Select State</option>
                            <option value="delhi">Delhi</option>
                            <option value="maharashtra">Maharashtra</option>
                            <option value="karnata">karnatka</option>
                          </select>
                        </div>
                      </div>

                      <div className="input-groups mb-1">
                        <div className="input-field address">
                          <label>Notes</label>

                          <textarea
                            name="notes"
                            placeholder="Note"
                            rows="4"
                            value={formValues.notes}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="payment-method">
                    <div className="checkout-product-data">
                      <div className="checkout-product-heading">
                        <h2 className="checkout-summary title mb-1">
                          Order Details
                        </h2>
                      </div>
                      <ul className="checkout-product-price-summary">
                        <li>
                          <span className="price-summary-left">Sub Total</span>
                          <span className="price-summary-right">
                            ₹ {subTotalAmount}/-
                          </span>
                        </li>
                        <li>
                          <span className="price-summary-left">GST (12%)</span>
                          <span className="price-summary-right">
                            ₹ {Math.round((subTotalAmount * 12) / 100)}/-
                          </span>
                        </li>
                        <li>
                          <span className="price-summary-left">
                            Pre Paid Discount (5%)
                          </span>
                          <span className="price-summary-right">
                            ₹ {Math.round((subTotalAmount * 5) / 100)}/-
                          </span>
                        </li>

                        <li>
                          <span className="price-summary-left">Total</span>
                          <span className="price-summary-right">
                            ₹ {payAmount}
                            /-
                          </span>
                        </li>
                      </ul>
                    </div>
                    <div className="payment-methods checkout-product-data">
                      <div className="checkout-product-heading">
                        <h2 className="checkout-summary title mb-1">
                          {checkCoupon ? "Coupon Applied" : "Apply Coupons"}
                        </h2>
                      </div>
                      <div className="coupon-div">
                        {checkCoupon ? (
                          <ul className="checkout-product-price-summary">
                            <li>
                              <span className="price-summary-left clr-gr">
                                You saved
                              </span>
                              <span className="price-summary-right clr-gr">
                                ₹ {Math.round((subTotalAmount * 5) / 100)}/-
                              </span>
                            </li>

                            <li>
                              <span className="price-summary-left">
                                Payable Amount
                              </span>
                              <span className="price-summary-right">
                                ₹ {payAmount}
                                /-
                              </span>
                            </li>
                          </ul>
                        ) : (
                          <div className="coupon-method-box">
                            <input
                              className="coupon-input"
                              type="text"
                              name="couponName"
                              value={couponValue}
                              onChange={(e) => setCouponValue(e.target.value)}
                            />
                            <button className="btn" onClick={applyValidCoupon}>
                              Apply
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="payment-methods">
                      <div className="checkout-product-heading">
                        <h2 className="checkout-summary title mb-1">
                          Payment Methods
                        </h2>
                      </div>
                      <div className="all-payment-radio">
                        <div className="payment-method-box">
                          <input
                            id="razorpay"
                            type="radio"
                            name="payment-type-selection"
                            value="razorpay"
                            checked={paymentMethod === "razorpay"}
                            onChange={onOptionChange}
                          />

                          <label htmlFor="razorpay" className="form-label">
                            <span>Razorpay</span>
                          </label>
                          <div className="card-body">
                            <p>
                              You can make online payment by Credit/Debit Card,
                              UPI, or Internet Banking.
                            </p>
                          </div>
                        </div>

                        <div className="payment-method-box">
                          <input
                            id="cod"
                            type="radio"
                            name="payment-type-selection"
                            value="cod"
                            checked={paymentMethod === "cod"}
                            onChange={onOptionChange}
                          />

                          <label htmlFor="cod" className="form-label">
                            <span>COD</span>
                          </label>
                          <div className="card-body">
                            <p>Cash on Delivery, is available here.</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <button
                      type="submit"
                      className="btn w-100"
                      onClick={newOrder}
                    >
                      Complete Order
                    </button>
                    <br />
                    <br />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Payment;
